<div id="{{ ruleId }}" *ngIf="!hideRule" class="wrapper {{ ruleClass }}" [ngClass]="type + (active ? ' active' : '')">
	<div class="rule-header">
		<div class="float-left">
			<div *ngIf="type === RULE_MESSAGE_TYPE.Info">
				<i class="fas fa-check"></i>
				<h6>{{ RULE_MESSAGE_TYPE.Info }}</h6>
			</div>
			<div *ngIf="type === RULE_MESSAGE_TYPE.Warning">
				<i class="fas fa-exclamation-triangle"></i>
				<h6>{{ RULE_MESSAGE_TYPE.Warning }}</h6>
			</div>
			<div *ngIf="type === RULE_MESSAGE_TYPE.Error">
				<i class="fas fa-ban"></i>
				<h6>{{ RULE_MESSAGE_TYPE.Error }}</h6>
			</div>
		</div>
		<div class="float-right">
			<span class="rule-update-instruction">Update</span>
			<div class="rule-actions">
				<button
					class="btn btn-sm btn-light"
					(click)="onUpdateStatus(RULE_STATUS.PASSED)"
					[disabled]="ruleStatus === RULE_STATUS.PASSED || disabledActions"
					[ngClass]="{ PASSED: ruleStatus === RULE_STATUS.PASSED }"
					title="Passed"
				>
					<i class="fas fa-check"></i>
				</button>
				<button
					class="btn btn-sm btn-light"
					(click)="onUpdateStatus(RULE_STATUS.FLAG)"
					[disabled]="ruleStatus === RULE_STATUS.FLAG || disabledActions"
					[ngClass]="{ FLAG: ruleStatus === RULE_STATUS.FLAG }"
					title="Flag"
				>
					<i class="fas fa-flag"></i>
				</button>
				<button
					class="btn btn-sm btn-light"
					(click)="onUpdateStatus(RULE_STATUS.FAILED)"
					[disabled]="ruleStatus === RULE_STATUS.FAILED || disabledActions"
					[ngClass]="{ FAILED: ruleStatus === RULE_STATUS.FAILED }"
					title="Failed"
				>
					<i class="fas fa-ban"></i>
				</button>
			</div>
		</div>
	</div>
	<hr class="separator" />
	<div class="rule-body"
		(click)="onRuleSelected()"
		[ngClass]="{
			'selectable-element': rule.multipleUiSections && rule.multipleUiSections.length <= 1
		}"
	>
		<div class="multiple-section">
			<label
				class="ui-section-lbl"
				*ngFor="let uiSection of rule.multipleUiSections; let i = index"
			>
				{{ uiSection.label }}{{ i === this.rule.multipleUiSections.length - 1 ? '' : ', ' }}
			</label>
		</div>
		<div
			class="rule-title"
			[ngClass]="{
				'selectable-element': rule.multipleUiSections && rule.multipleUiSections.length === 1
			}"
		>
			<a href="javascript:void(0);" >
				<h5 [innerHTML]="title | safeHtml"></h5>
			</a>
		</div>
		<div class="rule-badges">
			<span class="badge">{{ ruleSet }}</span>
			<span class="badge" *ngIf="category !== 'Unknown'">{{ category }}</span>
			<span class="badge" cvTooltip [tooltipText]="'AI-powered rule'" [tooltipPlacement]="'top'" *ngIf="isAI"><i class="fa-solid fa-robot"></i></span>
		</div>
		<div class="rule-description" [innerHTML]="description | safeHtml"></div>
		<div *ngIf="resolver" class="rule-resolver-message">
			<div *ngIf="resolver['wasResolved']" class="alert alert-primary">
				<span
					>Appraiser’s revision has resolved this <span class="text-lowercase">{{ type }}</span
					>.</span
				>
			</div>
			<div *ngIf="!resolver['wasResolved']" class="alert alert-danger">
				<span
					>Appraiser’s revision failed to resolve this <span class="text-lowercase">{{ type }}</span
					>.</span
				>
			</div>
		</div>
		<div
			class="multiple-section multiple-footer"
			*ngIf="rule.multipleUiSections && rule.multipleUiSections.length > 1"
		>
			<label>Focus the rule on:</label>
			<label
				(click)="onMultipleRuleSelected(uiSection)"
				class="ui-section-lbl selectable-element"
				*ngFor="let uiSection of rule.multipleUiSections; let i = index"
			>
				{{ uiSection.label }} <i class="fa fa-arrow-right"></i>
			</label>
		</div>
	</div>
	<div class="rule-footer">
		<div class="rule-button-options">
			<div class="rule-comments-wrapper" [ngClass]="{ 'is-add-disabled': disabledActions }">
				<div class="btn-group btn-group-sm cv-btn-group" role="group">
					<button
						type="button"
						class="btn btn-sm btn-light cv-btn-light"
						(click)="onViewComments()"
						title="View Comments"
					>
						<span>{{ commentCount }} Comments</span>
					</button>
					<button
						type="button"
						class="btn btn-sm btn-light cv-btn-light add-btn"
						(click)="onAddComment()"
						title="Add Comment"
						[disabled]="disabledActions"
					>
						<i class="fas fa-plus"></i>
					</button>
				</div>

				<div class="btn-group btn-group-sm cv-btn-group" role="group">
					<button
						type="button"
						class="btn btn-sm btn-light cv-btn-light"
						(click)="onViewStips()"
						title="View Stips"
					>
						<span>{{ stips.length }} Stips</span>
					</button>
					<button
						type="button"
						class="btn btn-sm btn-light cv-btn-light add-btn"
						[ngClass]="{ disabled: !rule.canAddStips }"
						(click)="onAddStip()"
						[disabled]="disabledActions || !rule.canAddStips"
					>
						<i class="fas fa-plus" title="Add Stip"></i>
					</button>
				</div>
			</div>
			<div class="rule-feedback-btn-wrapper">
				<button pButton
					class="p-button-secondary cv-feedback-btn"
					(click)="onFeedbackToggle()"
					[icon]="getFeedBackIcon()"
					[disabled]="disabledActions">
				</button>
			</div>
		</div>
		<div class="rule-comment" *ngIf="vendorNote">
			<div class="comment-header">{{ vendorNote?.createdBy?.fullName }} commented:</div>
			<div class="comment-container">
				<div
				  #commentRef
				  class="comment-body"
				  [innerHTML]="vendorNote?.note"
				  [ngClass]="{ 'clamped': !isExpanded }">
				</div>
			  
				<div *ngIf="shouldClamp" class="toggle-expand" (click)="toggleExpand()">
				  {{ isExpanded ? 'Show less' : 'Show more' }}
				</div>
			</div>
		</div>
		<cv-rule-feedback-component
			[orderId]="orderDetailModel.id"
			[documentId]="orderDetailModel.documentId"
			[ruleId]="rule.name" *ngIf="isFeedbackOpen && orderDetailModel && rule"
			(feedbackSuccess)="closeFeedback()" >
		</cv-rule-feedback-component>
	</div>
</div>
